import { render, staticRenderFns } from "./Starts.vue?vue&type=template&id=41dd50cc&"
import script from "./Starts.vue?vue&type=script&lang=js&"
export * from "./Starts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports